import { LabelInfo } from './get-recomendations'
import { getStrategy } from './get-strategy'

export function getLowerColsStrategy(
    info: LabelInfo,
    winding: number,
    cols: number,
    title: string
) {
    const optimalCols = getOptimalCols(info, winding, cols)
    return getStrategy(info, winding, optimalCols, title)
}

export function getOptimalCols([, copies]: LabelInfo, winding: number, maxCols: number) {
    for (let cols = maxCols; cols > 0; cols--) {
        const copiesInCol = copies / cols

        if (copiesInCol % winding === 0) {
            return cols
        }
    }

    return 0
}
